module.exports = __webpack_public_path__ + "04_mole.d69128c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer2/04_mole.png
// module id = X0Jw
// module chunks = 0